"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScopesPayload = exports.getEntityForTheSelectedItems = exports.getEnvironmentsById = void 0;

// Utility function to get environments by id or environmentId
var getEnvironmentsById = function getEnvironmentsById(environments) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

  if (environments && environments.length > 0) {
    var environmentsById = {};
    environments.forEach(function (env) {
      environmentsById[env[key]] = env; // Use dynamic key ('id' or 'environmentId')
    });
    return environmentsById || {};
  }

  return {};
};

exports.getEnvironmentsById = getEnvironmentsById;

var getEntityForTheSelectedItems = function getEntityForTheSelectedItems() {
  var updatedCheckedNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var environmentGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var environments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var updatedScope = {};
  updatedCheckedNodes.forEach(function (itemKey) {
    if (environments !== null && environments !== void 0 && environments[itemKey]) {
      updatedScope[itemKey] = {
        type: 'Environment',
        value: itemKey
      };
    } else if (environmentGroups !== null && environmentGroups !== void 0 && environmentGroups[itemKey]) {
      updatedScope[itemKey] = {
        type: 'EnvironmentGroup',
        value: itemKey
      };
    }
  });
  return getScopesPayload(updatedScope);
};

exports.getEntityForTheSelectedItems = getEntityForTheSelectedItems;

var getScopesPayload = function getScopesPayload() {
  var updatedScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.values(updatedScope).map(function (_ref) {
    var type = _ref.type,
        value = _ref.value;
    return {
      type: type,
      value: value
    };
  });
};

exports.getScopesPayload = getScopesPayload;